export const questions = [
  "Возникало ли у Вас ощущение того, что Вам следует сократить употребление спиртных напитков?",
  "Вызывало ли у Вас чувство раздражения, если кто-то из окружающих (друзья, родственники) говорил Вам о необходимости сократить употребление спиртных напитков?",
  "Испытывали ли Вы чувство вины, связанное с употреблением спиртных напитков?",
  "Возникало ли у Вас желание принять спиртное, как только Вы просыпались после имевшего места употребления алкогольных напитков?",
  "Употребляли ли Вы в течение последнего года наркотические вещества без назначения врача?",
  "Знаете ли Вы результаты своего последнего биохимического анализа крови (проведенного в течение последнего года)?",
];
